import { baseApi } from "./baseApi";
import { buildPaginationQueryString } from "./queryHelpers";
import { PaginateQuery } from "../../interfaces";

export const contactApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getContacts: builder.query<any, PaginateQuery>({
      query: (data) => ({
        url: buildPaginationQueryString(data, "/api/contact"),
      }),
      providesTags: ["Contacts"],
    }),
    getContact: builder.query<any, string>({
      query: (id) => ({
        url: `/api/contact/${id}`,
      }),
      providesTags: ["Contact"],
    }),
    addContact: builder.mutation<any, any>({
      query: (data) => ({
        url: "/api/contact",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Contacts"],
    }),
    updateContact: builder.mutation<any, { id: string; data: any }>({
      query: ({ id, data }) => ({
        url: `/api/contact/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["Contacts"],
    }),
    deleteContact: builder.mutation<any, string>({
      query: (id) => ({
        url: `/api/contact/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Contacts"],
    }),
  }),
});

export const {
  useGetContactsQuery,
  useGetContactQuery,
  useAddContactMutation,
  useUpdateContactMutation,
  useDeleteContactMutation,
} = contactApi;
